import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Pager,
  Paging,
  StateStoring,
  Button,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import Guid from "devextreme/core/guid";
import { useStyles } from "../../Styles.js";
import CustomStore from "devextreme/data/custom_store";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import RadioButton from "../RadioButton3.jsx";
import JobManagmentMasterDetailView from "./JobManagmentMasterDetailView";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ship_green from "../../assets/ship_green.svg";
import ship_red from "../../assets/ship_red.svg";
import DateBox from "devextreme-react/date-box";
import { useNavigate } from "react-router";
import Modal from "react-bootstrap/Modal";
import OrderLogDataView from "./OrderLogItemView";
import useDeviceSize from "../../hooks/useDeviceSize";
export function JobManagmentDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const gridRef = useRef(null);
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  localStorage.setItem("EMP_CODE", props.EMP_CODE);
  const [GET_CHECK_OWNER, SET_CHECK_OWNER] = useState("1");
  const classes = useStyles();
  const [getLoadGrid, setLoadGrid] = useState();
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [showManager, setShowManager] = useState(false);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [consigneeList, setConsigneeList] = useState([]);
  const [selectConsignee, setSelectConsignee] = useState([]);
  const [getConsignee, setConsignee] = useState([]);
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);

  const [getCS, setCS] = useState([]);
  const [CSList, setCSList] = useState([]);
  const [selectCS, setSelectCS] = useState([]);
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const pageSizes = [25, 50, 100];
  const [GET_REFNO, SET_REFNO] = useState("");
  const [GET_BOOKNO, SET_BOOKNO] = useState("");
  const [GET_SMFREF, SET_SMFREF] = useState("");
  const [logData, setLogData] = useState([]);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  // var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  var firstDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() - 30
  );
  var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  useEffect(() => {
    if (localStorage.getItem("setRadioStatus")) {
      let RadioStatus = localStorage.getItem("setRadioStatus");
      setRadioStatus(RadioStatus);
      SET_CHECK_OWNER(RadioStatus);
      if (RadioStatus == "1") {
        //my job
        setSelectCS(getCrmId);
        setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
      } else {
        setCS([]);
        setSelectCS([]);
      }
    } else {
      setRadioStatus(1);
      SET_CHECK_OWNER(1);
      setSelectCS(getCrmId);
      setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
    }

    if (localStorage.getItem("getSelectStatus")) {
      let stutus = localStorage.getItem("getSelectStatus");
      let stutus_label = localStorage.getItem("getSelectStatuslabel");
      setSelectStatus(stutus);
      setStatus({ value: stutus, label: stutus_label });
    }
    if (localStorage.getItem("getSelectSale2")) {
      let sale = localStorage.getItem("getSelectSale2");
      let sale_label = localStorage.getItem("getSelectSalelabel2");
      setSelectSale(sale);
      setSale({ SALE_CODE: sale, SALE_NAME: sale_label });
    }
    if (localStorage.getItem("getSelectShipper")) {
      let shipper = localStorage.getItem("getSelectShipper");
      let shipper_label = localStorage.getItem("getSelectShipperlabel");
      setSelectShipper(shipper);
      setShipper({ COM_CODE: shipper, COM_NAME: shipper_label });
    }
    if (localStorage.getItem("getSelectConsignee")) {
      let Consignee = localStorage.getItem("getSelectConsignee");
      let Consignee_label = localStorage.getItem("getSelectConsigneelabel");
      setSelectConsignee(Consignee);
      setConsignee({ COM_CODE: Consignee, COM_NAME: Consignee_label });
    }
  }, []);
  const optionsStatus = [
    { value: "1", label: "New" },
    { value: "2", label: "Received" },
    { value: "3", label: "Reject" },
    { value: "4", label: "Wait Carrier Release" },
    { value: "5", label: "Wait Sales to confirm" },
    { value: "6", label: "Sales confirm" },
    { value: "7", label: "BSE Created" },
    { value: "10", label: "BSE Confirmed" },
    { value: "11", label: "Open Job" },
    //{ value: "8", label: "BSE Pre Confirmed" },
    { value: "9", label: "Cancel" },
    //{ value: "8", label: "BSE Release" },
  ];
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
    localStorage.setItem("getSelectStatus", obj.value);
    localStorage.setItem("getSelectStatuslabel", obj.label);
  };
  const handleSearch = (e) => {
    //setSearchStatus(1);
  };
  // const clearFilter = useCallback(() => {
  //   gridRef.current.instance().clearFilter();
  // }, []);
  const handleClearInputClick = () => {
    //clearFilter();
    // const dataGrid = gridRef.current.instance();
    // dataGrid.clearFilter();
    if (getUserRole == 1) {
    } else {
      setSale([]);
      setSelectSale([]);
    }
    setStatus([]);
    setSelectStatus([]);
    setShipper([]);
    setSelectShipper([]);
    setConsignee([]);
    setSelectConsignee([]);
    if (GET_CHECK_OWNER == "1") {
      //my job
      setSelectCS(getCrmId);
      setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
    } else {
      setCS([]);
      setSelectCS([]);
    }
    localStorage.removeItem("getSelectStatus");
    localStorage.removeItem("getSelectStatuslabel");
    localStorage.removeItem("getSelectShipper");
    localStorage.removeItem("getSelectShipperlabel");
    localStorage.removeItem("getSelectCS");
    localStorage.removeItem("getSelectCSlabel");
    localStorage.removeItem("getSelectCS2");
    localStorage.removeItem("getSelectCSlabel2");
    localStorage.removeItem("getSelectConsignee");
    localStorage.removeItem("getSelectConsigneelabel");
    localStorage.removeItem("getSelectSale2");
    localStorage.removeItem("getSelectSalelabel2");
    localStorage.removeItem("currentSelectedRowKeys");
  };
  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const isChecked = (value) => radioRoleStatus === value;
  const [radioRoleStatus, setRadioStatus] = useState("1");
  const handleRadioChangeCheckRole = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "1") {
      //my job
      setSelectCS(getCrmId);
      setCS({ CS_ID: getCrmId, CS_EMAIL: getUserID });
      localStorage.setItem("setRadioStatus", 1);
      SET_CHECK_OWNER("1");
    } else if (event.target.value == "0") {
      //all job
      setCS([]);
      setSelectCS([]);

      localStorage.removeItem("getSelectCS");
      localStorage.removeItem("getSelectCSlabel");
      localStorage.setItem("setRadioStatus", 0);
      SET_CHECK_OWNER("0");
      localStorage.removeItem("getSelectCS2");
      localStorage.removeItem("getSelectCSlabel2");
    }
    setSearchStatus(0);
    if (getUserRole == 1) {
    } else {
      setSale([]);
      setSelectSale([]);
    }
    setStatus([]);
    setSelectStatus([]);
    setShipper([]);
    setSelectShipper([]);
    setConsignee([]);
    setSelectConsignee([]);
  };
  const token = process.env.REACT_APP_API_TOKEN;
  const getJobManagementDataSource = useMemo(() => {
    return new CustomStore({
      key: "ORDER_ID",
      load: async (loadOptions) => {
        const filters = JSON.stringify(loadOptions.filter ?? []); // ⭐
        console.log("🔍 filter =", loadOptions.filter); // ต้องมีค่า filter ส่งมาจริง
        const params = {
          crmid: getCrmId,
          status: selectStatus,
          sale: selectSale,
          cs: selectCS,
          shipper: selectShipper,
          cnee: selectConsignee,
          bookref: GET_REFNO,
          bookno: GET_BOOKNO,
          smfref: GET_SMFREF,
          parDateFrom: getDateFrom,
          parDateTo: getDateTo,
          load: getLoadGrid,
          skip: loadOptions.skip ?? 0,
          take: loadOptions.take ?? 5000,
          sortField: loadOptions.sort?.[0]?.selector ?? "LAST_UPDATE",
          sortOrder: loadOptions.sort?.[0]?.desc !== false ? "DESC" : "ASC",
          filters, // 👈 แปลง filter เป็น JSON string ส่งไป
          //ถ้ามีการ sort ข้อมูลใน DataGrid (loadOptions.sort) จะเอาชื่อคอลัมน์ที่เลือกเรียง (selector) มาใช้เป็น sortField
          //ถ้าไม่มีการ sort (เช่นเพิ่งโหลดหน้าครั้งแรก) จะ fallback ไปใช้ "LAST_UPDATE" เป็นค่าตั้งต้น (default sort field)
        };
        console.log("📦 Params ที่ส่งไป:", params);
        const queryString = new URLSearchParams(params).toString();
        console.log("🔗 Query String:", queryString);
        const response = await fetch(
          api_path + `/sales-order-cs-paging.php?${queryString}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const cleanData = result.data.map((item) => ({
          ...item,
          CNEE_NAME: item.CNEE_NAME?.trim() || "(ไม่มีข้อมูล)",
          SHIPPER_NAME: item.SHIPPER_NAME?.trim() || "(ไม่มีข้อมูล)",
          AGENT_NAME: item.AGENT_NAME?.trim() || "(ไม่มีข้อมูล)",
          COLOAD_NAME: item.COLOAD_NAME?.trim() || "(ไม่มีข้อมูล)",
          CS_NAME: item.CS_NAME?.trim() || "(ไม่มีข้อมูล)",
          SALE_NAME: item.SALE_NAME?.trim() || "(ไม่มีข้อมูล)",
          LAST_UPDATE: item.LAST_UPDATE || "-",
          SO_STATUS: item.SO_STATUS?.trim() || "(ไม่มีสถานะ)",
          BOOK_NO: item.BOOK_NO?.trim() || "-",
          REF_NO: item.REF_NO?.trim() || "-",
          SMF_REF: item.SMF_REF?.trim() || "-",
        }));

        return {
          data: cleanData,
          totalCount: result.totalCount ?? 0,
        };
      },
    });
  }, [
    getCrmId,
    selectStatus,
    selectSale,
    selectCS,
    selectShipper,
    selectConsignee,
    GET_REFNO,
    GET_BOOKNO,
    GET_SMFREF,
    getDateFrom,
    getDateTo,
    getLoadGrid,
    token,
  ]);
  // const urlJobManagement =
  //   api_path +
  //   "/sales-order-cs.php?sale=" +
  //   selectSale +
  //   "&cs=" +
  //   selectCS +
  //   "&crmid=" +
  //   getCrmId +
  //   "&userrole=" +
  //   GET_CHECK_OWNER +
  //   "&shipper=" +
  //   selectShipper +
  //   "&cnee=" +
  //   selectConsignee +
  //   "&status=" +
  //   selectStatus +
  //   "&bookref=" +
  //   GET_REFNO +
  //   "&bookno=" +
  //   GET_BOOKNO +
  //   "&smfref=" +
  //   GET_SMFREF +
  //   "&parDateFrom=" +
  //   getDateFrom +
  //   "&parDateTo=" +
  //   getDateTo +
  //   "&load=" +
  //   getLoadGrid;
  // const getJobManagementDataSource = createStore({
  //   key: "ORDER_ID",
  //   loadUrl: urlJobManagement,
  //   reshapeOnPush: true,
  //   onBeforeSend(method, ajaxOptions) {
  //     ajaxOptions.crossDomain = true;
  //     ajaxOptions.xhrFields = { withCredentials: true };
  //     ajaxOptions.headers = {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     };
  //   },
  // });
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  useEffect(() => {
    const getSalesDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/GET_SALES.php?role=${getUserRole}&user=${getCrmId}&checkmanager=${GET_CHECK_OWNER}`
      );
      const getst = resstate.json();
      setSaleList(await getst);
    };
    getSalesDropdown().then();
  }, [GET_CHECK_OWNER]);
  const handleSaleChange = (obj) => {
    setSelectSale(obj.SALE_CODE);
    setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
    localStorage.setItem("getSelectSale2", obj.SALE_CODE);
    localStorage.setItem("getSelectSalelabel2", obj.SALE_NAME);
  };
  useEffect(() => {
    const getCSDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/GET_CS.php?role=${getUserRole}&user=${getCrmId}&checkOwner=${GET_CHECK_OWNER}`
      );
      const getst = resstate.json();
      setCSList(await getst);
    };
    getCSDropdown().then();
  }, [GET_CHECK_OWNER]);
  const handleCSChange = (obj) => {
    setSelectCS(obj.CS_ID);
    setCS({ CS_ID: obj.CS_ID, CS_EMAIL: obj.CS_EMAIL });
    localStorage.setItem("getSelectCS2", obj.CS_ID);
    localStorage.setItem("getSelectCSlabel2", obj.CS_EMAIL);
  };
  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=SHIPPER`
      );
      const getst = resstate.json();
      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, [getSale.SALE_CODE]);
  const handleShipperChange = (obj) => {
    setSelectShipper(obj.COM_CODE);
    setShipper({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectShipper", obj.COM_CODE);
    localStorage.setItem("getSelectShipperlabel", obj.COM_NAME);
  };
  useEffect(() => {
    const getCNEEDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=CONSIGNEE`
      );
      const getst = resstate.json();
      setConsigneeList(await getst);
    };
    getCNEEDropdown().then();
  }, [getSale]);
  const handleConsigneeChange = (obj) => {
    setSelectConsignee(obj.COM_CODE);
    setConsignee({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectConsignee", obj.COM_CODE);
    localStorage.setItem("getSelectConsigneelabel", obj.COM_NAME);
  };
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SalesOrder.xlsx"
        );
      });
    });
  };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "ORDER_STATUS_NAME") {
        e.cellElement.innerHTML =
          "<p class='status" +
          e.data.ORDER_STATUS +
          "'><a href='SalesOrderDetail?order_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #FFFFFF;'>" +
          e.data.ORDER_STATUS_NAME +
          "</a></p>";
      } else if (e.column.dataField === "ORDER_NO") {
        e.cellElement.innerHTML =
          "<p style='color: #000;background-color: #EBEBEB;text-align:center;'><a href='SalesOrderDetail?order_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #000;'>" +
          e.data.ORDER_NO +
          "</a></p>";
      } else if (e.column.dataField === "ACTIVE_ITEM") {
        if (e.data.ACTIVE_ITEM === "1") {
          e.cellElement.innerHTML = "<img src=" + ship_green + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "2") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "3") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/><img src=" +
            ship_green +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.ACTIVE_ITEM === "0") {
          e.cellElement.innerHTML = "";
        } else {
          e.cellElement.innerHTML = "<img src=" + ship_green + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        }
      } else if (e.column.dataField === "INACTIVE_ITEM") {
        if (e.data.INACTIVE_ITEM === "1") {
          e.cellElement.innerHTML = "<img src=" + ship_red + " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "2") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "3") {
          e.cellElement.innerHTML =
            "<img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/><img src=" +
            ship_red +
            " width='16'/>";
          e.cellElement.style.cssText = "text-align:left;";
        } else if (e.data.INACTIVE_ITEM === "0") {
          e.cellElement.innerHTML = "";
        } else {
          e.cellElement.innerHTML = "";
        }
      } else if (
        e.column.dataField === "LOADTYPE" &&
        (e.data.LOADTYPE == "FCL" ||
          e.data.LOADTYPE == "DIRECT-FCL" ||
          e.data.LOADTYPE == "CONSOLE")
      ) {
        e.cellElement.innerHTML =
          "<p style='background-color: #ffd365;text-align:center;'>" +
          e.data.LOADTYPE +
          "</p>";
      } else if (
        e.column.dataField === "LOADTYPE" &&
        (e.data.LOADTYPE == "LCL" || e.data.LOADTYPE == "DIRECT-LCL")
      ) {
        e.cellElement.innerHTML =
          "<p style='background-color: #abffff;text-align:center;'>" +
          e.data.LOADTYPE +
          "</p>";
      }
    }
  };
  const cellPreparedLog = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "STATUS") {
        e.cellElement.innerHTML =
          "<p class='status" + e.data.STATUS_ID + "'>" + e.data.STATUS + "</p>";
      }
    }
  };
  const [mode, setMode] = useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = useState(true);
  const [allowSelectAll, setAllowSelectAll] = useState(true);
  const [selectByClick, setSelectByClick] = useState(true);
  const [recursive, setRecursive] = useState(true);
  //end column chooser
  const Search = () => {
    const [showResults, setShowResults] = useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );
  // useCallback เป็น React Hook ที่ใช้สำหรับการสร้าง function ที่มีการ caching ใน memory
  // ค่าที่ return จาก useCallback จะไม่เปลี่ยนจนกว่า dependencies ใน array ที่ระบุไว้ให้จะเปลี่ยนแปลง
  // ซึ่งมีประโยชน์ในการประหยัด performance เมื่อมีการ render ซ้ำ ๆ
  const onRefreshClick = useCallback(() => {
    setLoadGrid(randomNumberInRange(1, 20));
  }, []);
  const navigate = useNavigate();
  const handleAddButtonClick = useCallback((e) => {
    navigate({
      pathname: "/s-crm/OpenJobManagement",
      search: "",
    });
  }, []);
  function onShowlogButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchItemData(e.row.key);
    setShowLog(true);
  }
  const showLogData = true;
  const fetchItemData = async (ORDER_ID) => {
    const response = await fetch(
      api_path + "/GET_ORDER_LOG.php?ORDER_ID=" + ORDER_ID
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (props.logData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">STATUS</th>
              <th scope="col">DATE</th>
              <th scope="col"></th>
              <th scope="col">Modified By</th>
              <th scope="col">DETAIL</th>
              <th scope="col">REMARK</th>
            </tr>
          </thead>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <OrderLogDataView
                    key={fdata.INQUIRY_ITEM_ID}
                    id={fdata.ORDER_ID}
                    STATUS_ID={fdata.STATUS_ID}
                    STATUS={fdata.STATUS}
                    USERNAME={fdata.USERNAME}
                    EVENT_DATE={fdata.EVENT_DATE}
                    DATE_TEXT={fdata.DATE_TEXT}
                    REMARK={fdata.REMARK}
                    REVISED_COLUMNS={fdata.REVISED_COLUMNS}
                  />
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  const updateGridData = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const renderDetailSection = useCallback(({ data }) => {
    return DetailSection(data, updateGridData);
  }, []);
  const [modeSize, setModeSize] = useState("widget");
  return (
    <Container maxWidth="xl">
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sales Order Log</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
          {/* {localStorage.getItem('currentSelectedRowKeys') && (
            <div>
               Name: <p>{localStorage.getItem('currentSelectedRowKeys')}</p>
            </div>
         )} */}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">
            CS Job Management <SupportAgentIcon fontSize="large" />
          </label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            Open Job
          </Button1>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <br />
          <RadioButton
            name="CHECK_ROLE"
            value="1"
            text="My Job"
            onChange={handleRadioChangeCheckRole}
            checked={isChecked("1")}
          />
          <RadioButton
            name="CHECK_ROLE"
            value="0"
            text="All Job"
            onChange={handleRadioChangeCheckRole}
            checked={isChecked("0")}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Create Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>BOOKING REF</label>
          <TextField
            size="small"
            name="GET_REFNO"
            variant="outlined"
            fullWidth
            id="GET_REFNO"
            value={GET_REFNO}
            onChange={(e) => SET_REFNO(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>BOOKING NO</label>
          <TextField
            size="small"
            name="GET_BOOKNO"
            variant="outlined"
            fullWidth
            id="GET_BOOKNO"
            value={GET_BOOKNO}
            onChange={(e) => SET_BOOKNO(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>SMF REF</label>
          <TextField
            size="small"
            name="GET_SMFREF"
            variant="outlined"
            fullWidth
            id="GET_SMFREF"
            value={GET_SMFREF}
            onChange={(e) => SET_SMFREF(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}></Grid>

        <Grid item xs={12} sm={2}>
          <label>CS</label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={getCS}
            options={CSList}
            onChange={handleCSChange}
            getOptionLabel={(x) => x.CS_EMAIL}
            getOptionValue={(x) => x.CS_ID}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>SALES</label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Customer</label>
          <Select
            className="multiselect3"
            placeholder="Select..."
            value={getShipper}
            options={shipperList}
            onChange={handleShipperChange}
            getOptionLabel={(x) => x.COM_NAME}
            getOptionValue={(x) => x.COM_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Consignee</label>
          <Select
            className="multiselect4"
            placeholder="Select..."
            value={getConsignee}
            options={consigneeList}
            onChange={handleConsigneeChange}
            getOptionLabel={(x) => x.COM_NAME}
            getOptionValue={(x) => x.COM_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Status</label>
          <Select
            className="multiselect5"
            placeholder="Select"
            value={getStatus}
            options={optionsStatus}
            onChange={handleStatusChange}
          />
        </Grid>
        <Grid item xs={12} sm={8}></Grid>
        <Grid item xs={12} sm={4}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="info"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>{" "}
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>

        <Grid item xs={12} sm={3}></Grid>
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          id="JobManagementContainer"
          onCellPrepared={cellPrepared}
          dataSource={getJobManagementDataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="ORDER_ID"
          onExporting={onExporting}
          ref={gridRef}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
          //remoteOperations={{ filtering: true, sorting: true, paging: true }}
          //remoteOperations={false} // ลองปิดเพื่อดูว่า filter client-side ทำงานไหม
          // onToolbarPreparing={(e) => {
          //   e.toolbarOptions.items.unshift({
          //     location: "after",
          //     widget: "dxButton",
          //     options: {
          //       icon: "clear",
          //       text: "ล้างตัวกรอง",
          //       onClick: () => e.component.clearFilter(),
          //     },
          //   });
          // }}
        >
          {/* localStorage.removeItem("storageJobManagement3") */}
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="storageJobManagement3"
          />
          <MasterDetail enabled={true} render={renderDetailSection} />
          {/* <Column
  caption="Check Row"
  calculateDisplayValue={(row) => JSON.stringify(row).substring(0, 100)}
/> */}
          <FilterRow visible={true} applyFilter="auto" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="ORDER_ID"
            defaultSortOrder="desc"
            visible={false}
          />
          <Column dataField="USER_ID" width={80} visible={false} />
          <Column dataField="ORDER_NO" caption="ORDER No." width={100} />
          <Column
            dataField="ORDER_DATE"
            caption="Create Date"
            dataType="date"
            format="dd-MMM-yy hh:mm:ss a"
            visible={false}
          />
          <Column dataField="CUSTOMER_REF" caption="CUST. REF" width={90} />
          <Column dataField="SHIPPER_CODE" caption="CODE" visible={false} />
          <Column dataField="SHIPPER_NAME" caption="CUSTOMER" width={160} />
          <Column dataField="CNEE_CODE" caption="CODE" visible={false} />
          <Column dataField="CNEE_NAME" caption="CNEE" width={160} />
          <Column dataField="POL" width={80} />
          <Column dataField="POD" width={80} />
                  <Column dataField="DEL" width={80} />
          <Column
            dataField="CARRIER_CODE"
            caption="CARRIER"
            width={100}
            visible={false}
          />
          <Column
            dataField="SERVICES_CONTRACT"
            caption="S/C"
            width={120}
            visible={false}
          />
          <Column
            dataField="CARGO_READY"
            caption="CRD"
            dataType="date"
            format="dd-MMM-yyyy"
            width={100}
          />
          <Column
            dataField="ETD_DATE"
            caption="ETD"
            dataType="date"
            format="dd-MMM-yyyy"
            width={100}
          />
          <Column dataField="CNT20" caption="20'" width={50} />
          <Column dataField="CNT40" caption="40'" width={50} />
          <Column dataField="CNT40HQ" caption="40HQ" width={50} />
          <Column dataField="CNT45" caption="45" width={50} />
          <Column dataField="TYPE20" visible={false} />
          <Column dataField="TYPE40" visible={false} />
          <Column dataField="TYPE40HQ" visible={false} />
          <Column dataField="TYPE45" visible={false} />
          <Column dataField="GW" visible={false} />
          <Column dataField="NO_OF_PACK" visible={false} />
          <Column dataField="PACKAGE_UNIT" visible={false} />
          <Column dataField="CBM" visible={false} />
          <Column dataField="BOOK_PRIORITY" visible={false} />
          <Column dataField="WAITING_FLAG" visible={false} />
          <Column dataField="LOADTYPE" caption="LOADTYPE" width={100} />
          <Column dataField="INCOTERM" caption="INCO" width={70} />
          <Column dataField="CREATE_BY" caption="Creater" width={80} />
          <Column dataField="CS_NAME" caption="CS" width={80} />
          <Column dataField="BKG_NAME" caption="BKG" visible={false} />
          <Column dataField="SENDER_NAME" caption="SENDER" visible={false} />
          <Column dataField="ACTIVE_ITEM" caption="ACTIVE" width={80} />
          <Column dataField="INACTIVE_ITEM" caption="INACTIVE" width={50} />
          <Column dataField="ORDER_STATUS" visible={false} />
          <Column
            dataField="LAST_UPDATE"
            caption="Update"
            width={115}
            dataType="date"
            sortOrder="desc" 
            format="dd-MMM-yy hh:mm:ss a"
          />
          <Column dataField="ORDER_STATUS_NAME" caption="STATUS" width={100} />
          <Column dataField="CHECK_MANAGER" visible={false} />
          <Column type="buttons" caption="Log" width="5%">
            <Button
              icon="eyeopen"
              onClick={onShowlogButtonClick}
              hint="Click to view log details"
            />
          </Column>
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
const DetailSection = (data, updateGridData) => {
  return (
    <JobManagmentMasterDetailView
      ORDER_ID={data.ORDER_ID}
      ORDER_STATUS={data.ORDER_STATUS}
      SHIPPER_CODE={data.SHIPPER_CODE}
      CNEE_CODE={data.CNEE_CODE}
      CARRIER_CODE={data.CARRIER_CODE}
      SERVICES_CONTRACT={data.SERVICES_CONTRACT}
      BULLET_CODE={data.BULLET_CODE}
      SCAC={data.SCAC}
      CNT20={data.CNT20}
      CNT40={data.CNT40}
      CNT40HQ={data.CNT40HQ}
      CNT45={data.CNT45}
      GW={data.GW}
      BOOK_PRIORITY={data.BOOK_PRIORITY}
      WAITING_FLAG={data.WAITING_FLAG}
      POR={data.POR}
      POL={data.POL}
      POD={data.POD}
      DEL={data.DEL}
      FINAL={data.FINAL}
      INLAND_POSTCODE={data.INLAND_POSTCODE}
      USER_ID={data.USER_ID}
      sendDataToParent={updateGridData}
    />
  );
};
